import { createContext, useContext, useEffect, useState } from "react";
import { api, clearLegacyTokens, formatErr } from "@/lib/api";
import { toast } from "sonner";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    clearLegacyTokens();
    let active = true;
    api.get("/auth/me").then((r) => { if (active) setUser(r.data); }).catch(() => { if (active) setUser(false); });
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data.user);
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
      clearLegacyTokens();
      setUser(false);
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return <AuthCtx.Provider value={{ user, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
